import React from 'react';
import './CreateTicketButton.css';
import { Link } from 'react-router-dom'


export default function CreateTicketButton() {
    return (

        <div className="button-ticket">
            <Link to={`/modal/criarTicket`}>
                <button className="btn-ticket">
                   Criar Ticket &nbsp;
                        <i className="fas fa-ticket-alt"></i>
                </button>
            </Link>
        </div>
    )
}